module.exports = __webpack_public_path__ + "img/diplome-etat-controle.56af874.png";